import Vue from 'vue';

function getInvitationTypes(params) {
  return Vue.http.get('invited_type', { params });
}

export default {
  getInvitationTypes,
}



// WEBPACK FOOTER //
// ./src/services/InvitationTypeService.js